import { UserProfileProps, UserProfileEditorProps, VarFields, BasicFieldsConfig } from './UserProfile.types';

/**
 * 기존 데이터 형식을 새로운 형식으로 변환
 * 
 * @param originalProps 기존 컴포넌트의 props
 * @returns 변환된 새로운 컴포넌트용 props
 */
export function adaptUserProfileProps(originalProps: any): UserProfileProps {
  // 기본값 설정 (빈 객체로 초기화)
  const originalContent = originalProps?.content || {};
  const originalData = originalProps?.data || {};
  const originalComponentProps = originalProps?.componentProps || {};
  const originalPathVariables = originalProps?.pathVariables || {};
  
  // 커스텀 필드 (varFields) 설정 - 여러 경로에서 확인
  // 1. originalProps.varFields
  // 2. component.componentProps.varFields
  // 3. 개별 필드 별로 확인
  const varFields: VarFields = {
    var01: originalProps?.varFields?.var01 || 
           originalComponentProps?.varFields?.var01 || 
           { 
             show: originalProps?.varFields?.var01?.show || originalComponentProps?.varFields?.var01?.show || false, 
             label: originalProps?.varFields?.var01?.label || originalComponentProps?.varFields?.var01?.label || "" 
           },
    var02: originalProps?.varFields?.var02 || 
           originalComponentProps?.varFields?.var02 || 
           { 
             show: originalProps?.varFields?.var02?.show || originalComponentProps?.varFields?.var02?.show || false, 
             label: originalProps?.varFields?.var02?.label || originalComponentProps?.varFields?.var02?.label || "" 
           },
    var03: originalProps?.varFields?.var03 || 
           originalComponentProps?.varFields?.var03 || 
           { 
             show: originalProps?.varFields?.var03?.show || originalComponentProps?.varFields?.var03?.show || false, 
             label: originalProps?.varFields?.var03?.label || originalComponentProps?.varFields?.var03?.label || "" 
           }
  };
  
  // 기본 회원정보 필드 설정
  const defaultBasicFields: BasicFieldsConfig = {
    userId: true,
    name: true,
    password: true,
    phone: true,
    email: true,
    birthday: true,
    createdAt: true,
    address: true,
    referralLink: true
  };
  
  // basicFields 병합 (props, componentProps 또는 기본값)
  const basicFields: BasicFieldsConfig = {
    ...defaultBasicFields,
    ...(originalProps?.basicFields || {}),
    ...(originalComponentProps?.basicFields || {})
  };
  
  // 콘텐츠 제목 설정 (content.title)
  const content = {
    ...originalContent,
    title: originalContent?.title || originalComponentProps?.title || '회원 정보'
  };
  
  // 스타일 병합 (깊은 복사로 병합)
  const style = {
    ...(originalProps?.style || {}),
    ...(originalComponentProps?.style || {})
  };
  
  // 인라인 스타일과 CSS 클래스 통합
  if (originalProps.defaultStyle) {
    Object.assign(style, originalProps.defaultStyle);
  }

  // className 설정
  const className = originalProps?.className || originalComponentProps?.className || '';


  // 변환된 props 반환
  const adaptedProps: UserProfileProps = {
    content,
    style,
    className,
    data: originalData,
    componentProps: {
      ...originalComponentProps,
    },
    pathVariables: originalPathVariables,
    varFields,
    basicFields,
    id: originalProps?.id || '',
  };

  // 원본 props의 모든 속성 중 이미 처리한 속성 제외하고 나머지 복사
  const excludeKeys = ['content', 'style', 'className', 'data', 'componentProps', 'pathVariables', 'varFields', 'basicFields', 'id'];
  
  Object.keys(originalProps).forEach(key => {
    if (!excludeKeys.includes(key)) {
      adaptedProps[key] = originalProps[key];
    }
  });



  return adaptedProps;
}

/**
 * 에디터용 데이터 형식 변환
 * 
 * @param originalProps 기존 컴포넌트의 props
 * @returns 변환된 에디터 컴포넌트용 props
 */
export function adaptUserProfileEditorProps(originalProps: any): UserProfileEditorProps {
  // 기본 props 변환 사용
  const adaptedProps = adaptUserProfileProps(originalProps) as UserProfileProps;
  
  // 에디터 관련 추가 props
  return {
    ...adaptedProps,
    isSelected: originalProps.isSelected || false,
    isPreview: originalProps.isPreview || false,
    viewMode: originalProps.viewMode || 'pc',
    updateComponent: originalProps.updateComponent || (() => {
      console.warn('UserProfile: updateComponent 함수가 없습니다');
    })
  };
} 